import {
    CREATE_ACTIVITY_TEMPLATE_REQUEST,
    CREATE_ACTIVITY_TEMPLATE_SUCCESS,
    CREATE_ACTIVITY_TEMPLATE_FAIL,
    READ_ACTIVITY_TEMPLATE_BY_ID_REQUEST,
    READ_ACTIVITY_TEMPLATE_BY_ID_SUCCESS,
    READ_ACTIVITY_TEMPLATE_BY_ID_FAIL,
    UPDATE_ACTIVITY_TEMPLATE_REQUEST,
    UPDATE_ACTIVITY_TEMPLATE_SUCCESS,
    UPDATE_ACTIVITY_TEMPLATE_FAIL,
    DELETE_ACTIVITY_TEMPLATE_REQUEST,
    DELETE_ACTIVITY_TEMPLATE_SUCCESS,
    DELETE_ACTIVITY_TEMPLATE_FAIL,
    READ_ACTIVITY_TEMPLATE_REQUEST,
    READ_ACTIVITY_TEMPLATE_SUCCESS,
    READ_ACTIVITY_TEMPLATE_FAIL,
} from '../constant';

import { apiRequest } from "../../../survey-ui/services/apiService";

// Action to create a new activity template
export const createActivityTemplate = (templateData) => {
    console.log("template data----",templateData);
    return async (dispatch) => {
        dispatch({ type: CREATE_ACTIVITY_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/activity-log-templates/create-activity-log`,
            data: templateData,
            showErrorToast: false,
        });

        if (response) {
            dispatch({ type: CREATE_ACTIVITY_TEMPLATE_SUCCESS, payload: response.data });
        } else if (error) {
            dispatch({ type: CREATE_ACTIVITY_TEMPLATE_FAIL, payload: error.message });
        }
    };
};

// Action to read an activity template by ID
export const readActivityTemplateById = (templateId) => {
    return async (dispatch) => {
        dispatch({ type: READ_ACTIVITY_TEMPLATE_BY_ID_REQUEST });
        const { response, error } = await apiRequest({
            method: "GET",
            url: `/activity-templates/${templateId}`,
        });

        if (response) {
            dispatch({ type: READ_ACTIVITY_TEMPLATE_BY_ID_SUCCESS, payload: response.data });
        } else if (error) {
            dispatch({ type: READ_ACTIVITY_TEMPLATE_BY_ID_FAIL, payload: error.message });
        }
    };
};

// Action to update an existing activity template
export const updateActivityTemplate = (templateData) => {
    console.log("template sdata---",templateData)

    return async (dispatch) => {
        dispatch({ type: UPDATE_ACTIVITY_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: "PATCH",
            url: `/activity-log-templates/update-activity-log`,
            data: templateData,
            showErrorToast: false,
        });

        if (response) {
            dispatch({ type: UPDATE_ACTIVITY_TEMPLATE_SUCCESS, payload: response.data });
        } else if (error) {
            dispatch({ type: UPDATE_ACTIVITY_TEMPLATE_FAIL, payload: error.message });
        }
    };
};

// Action to delete an activity template
export const deleteActivityTemplate = (templateData) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_ACTIVITY_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: "DELETE",
            url: `/activity-log-templates/delete`,
            data: templateData,
            showErrorToast: false,
        });

        if (response) {
            dispatch({ type: DELETE_ACTIVITY_TEMPLATE_SUCCESS, payload: templateData.activity_log_template_id });
            return Promise.resolve(response.data);
        } else if (error) {
            dispatch({ type: DELETE_ACTIVITY_TEMPLATE_FAIL, payload: error.message });
            return Promise.reject(error.message);
        }
    };
};


export const readActivityTemplates = (data) => {
    return async (dispatch) => {
        dispatch({ type: READ_ACTIVITY_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/activity-log-templates/get-activity-log-list`,
            data: data,
        });

        if (response) {
            dispatch({
                type: READ_ACTIVITY_TEMPLATE_SUCCESS,
                payload: response.data, // Contains both data and pagination
            });
        } else if (error) {
            dispatch({ type: READ_ACTIVITY_TEMPLATE_FAIL, payload: error.message });
        }
    };
};


